import React, { FC, useEffect, useState } from "react";
// import facebookSvg from "images/Facebook.svg";
// import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister, getUser } from "actions/userActions";
import { useHistory } from "react-router-dom";
import { RootState } from "store";
import { IInput, ILoginSocial } from "types/interfaces";
import Error from "shared/Error";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";

export interface PageSignUpProps {
	className?: string;
}

const loginSocials: ILoginSocial[] = [
	{
		name: "Daftar melalui Google",
		icon: googleSvg,
		method: "google",
	},
	// {
	//   name: "Daftar melalui Facebook",
	//   icon: facebookSvg,
	//   method: "facebook",
	// },
	// {
	//   name: "Daftar melalui Twitter",
	//   icon: twitterSvg,
	//   method: "twitter",
	// },
];

const PageSignUp: FC<PageSignUpProps> = ({ className = "" }) => {
	// buat nanti loncat ke homepage kalau user dah login
	const history = useHistory();

	// State input yang diminta nanti
	const [name, setName] = useState<IInput>({ value: "", warning: "" });
	const [phone, setPhone] = useState<IInput>({ value: "", warning: "" });
	const [email, setEmail] = useState<IInput>({ value: "", warning: "" });
	const [password, setPassword] = useState<IInput>({
		value: "",
		warning: "",
		peek: false,
	});
	const [password2, setPassword2] = useState<IInput>({
		value: "",
		warning: "",
		peek: false,
	});
	const [agreement, setAgreement] = useState(true);

	// Fungsi dispatch
	const dispatch = useDispatch();

	// Store untuk redux ttg userInfo
	const { userInfo, loading, error } = useSelector(
		(state: RootState) => state.userInfo
	);

	// Andaikata user dah login langsung dilempar
	useEffect(() => {
		if (userInfo) {
			const redirect = window.location.search?.split("=")[1] || "/";
			history.push(redirect);
		}
	}, [userInfo]);

	// Andaikata user pencet login, nanti ada warning kalau ga bener ngisinya
	const handleSubmit = (e: any) => {
		e.preventDefault();
		if (!name.value) {
			setName({ value: name.value, warning: "Masukkan nama lengkap anda" });
		}

		if (!email.value) {
			setEmail({
				value: email.value,
				warning: "Masukkan email anda",
			});
		}

		if (!phone.value) {
			setPhone({
				value: phone.value,
				warning: "Masukkan nomor telepon anda",
			});
		}
		if (!password.value) {
			setPassword({
				value: password.value,
				warning: "Masukkan password",
			});
		}

		if (!password2.value) {
			setPassword2({
				value: password2.value,
				warning: "Masukkan password",
			});
		}

		if (password.value !== password2.value) {
			setPassword2({
				value: password2.value,
				warning: "Masukkan password yang sama",
			});
		} else if (
			name.value &&
			email.value &&
			phone.value &&
			password.value &&
			password2.value &&
			!agreement &&
			!name.warning &&
			!email.warning &&
			!phone.warning &&
			!password.warning &&
			!password2.warning
		)
			dispatch(
				userRegister(name.value, email.value, password.value, phone.value)
			);
	};

	// Function untuk handle auth dari social
	const handleAuth = async (method: string) => {
		logging("", {
			category: "user",
			action: "register",
			target: "google",
		});
		const popup = window.location.href.includes("localhost")
			? `http://localhost:8000/api/auth/${method}`
			: `https://rentrips.id/api/auth/${method}`;
		let timer: NodeJS.Timeout | null = null;
		const newWindow = window.open(popup, "_blank", "width=500,height=600");

		if (newWindow) {
			timer = setInterval(() => {
				if (newWindow.closed) {
					dispatch(getUser());
					if (timer) clearInterval(timer);
				}
			}, 500);
		}
	};

	return (
		<div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
			<Helmet>
				<title>Daftar</title>
			</Helmet>
			{error && <Error>{error}</Error>}
			<div className="container mb-24 lg:mb-32">
				<h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
					Daftar
				</h2>
				<div className="max-w-md mx-auto space-y-6 ">
					{/* FORM */}
					<form
						className="grid grid-cols-2 gap-6"
						onSubmit={handleSubmit}
						autoComplete="off"
					>
						<label className="block col-span-2">
							<span className="text-neutral-800 dark:text-neutral-200">
								Nama Lengkap
							</span>
							<Input
								type="text"
								placeholder="Nama Anda"
								className="mt-1"
								value={name.value}
								onChange={(e) =>
									setName({ value: e.target.value, warning: "" })
								}
							/>
							{name.warning && (
								<span className="text-red-600 text-sm">{name.warning}</span>
							)}
						</label>
						<label className="block col-span-2">
							<span className="text-neutral-800 dark:text-neutral-200">
								Nomor Telepon
							</span>
							<div className="flex items-center">
								<span className="h-11 px-4 py-3 dark:border-neutral-700">
									+62
								</span>
								<Input
									type="tel"
									placeholder="8123123123"
									className="mt-1"
									value={phone.value}
									onChange={(e) => {
										if (isNaN(Number(e.target.value))) return;
										setPhone({ value: e.target.value, warning: "" });
										if (phone.value.length < 9) {
											setPhone({
												value: e.target.value,
												warning: "Masukkan nomor yang tepat",
											});
										}
									}}
								/>
							</div>
							{phone.warning && (
								<span className="text-red-600 text-sm">{phone.warning}</span>
							)}
						</label>
						<label className="block col-span-2">
							<span className="text-neutral-800 dark:text-neutral-200">
								Email
							</span>
							<Input
								type="email"
								placeholder="contoh@email.com"
								className="mt-1"
								value={email.value}
								onChange={(e) =>
									setEmail({ value: e.target.value, warning: "" })
								}
							/>
							{email.warning && (
								<span className="text-red-600 text-sm">{email.warning}</span>
							)}
						</label>
						<label className="block col-span-2">
							<span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
								Password
							</span>
							<div className="relative">
								{" "}
								<Input
									type={password.peek ? "text" : "password"}
									className="mt-1"
									placeholder="password"
									value={password.value}
									warning={password.warning}
									autoComplete="new-password"
									onKeyUp={(e) => {
										if (password.value.length < 8) {
											setPassword({
												...password,
												warning: "Password minimal 8 karakter",
											});
										} else {
											setPassword({ ...password, warning: "" });
										}
									}}
									onChange={(e) => {
										if (e.target.value !== password2.value) {
											setPassword2({
												...password2,
												warning: "Password tidak sama",
											});
										} else {
											setPassword2({ ...password2, warning: "" });
										}
										setPassword({ ...password, value: e.target.value });
									}}
								/>
								{password.peek ? (
									<EyeOffIcon
										className="w-5 h-5 absolute right-4 top-3 dark:text-neutral-200 text-neutral-400"
										onClick={(e) => {
											setPassword({ ...password, peek: false });
											e.preventDefault();
										}}
									/>
								) : (
									<EyeIcon
										className="w-5 h-5 absolute right-4 top-3 dark:text-neutral-200 text-neutral-400"
										onClick={(e) => {
											setPassword({ ...password, peek: true });
											e.preventDefault();
										}}
									/>
								)}
							</div>
						</label>
						<label className="block col-span-2">
							<span className="flex text-neutral-800 dark:text-neutral-200">
								Ulangi Password
							</span>
							<div className="relative">
								<Input
									type={password2.peek ? "text" : "password"}
									placeholder="ulangi password"
									className="mt-1"
									value={password2.value}
									warning={password2.warning}
									autoComplete="off"
									onChange={(e) => {
										if (password.value !== e.target.value) {
											setPassword2({
												peek: password2.peek,
												value: e.target.value,
												warning: "Password tidak sama",
											});
										} else
											setPassword2({
												value: e.target.value,
												warning: "",
												peek: password2.peek,
											});
									}}
								/>
								{password2.peek ? (
									<EyeOffIcon
										className="w-5 h-5 absolute right-4 top-3 dark:text-neutral-200 text-neutral-400"
										onClick={(e) => {
											setPassword2({ ...password2, peek: false });
											e.preventDefault();
										}}
									/>
								) : (
									<EyeIcon
										className="w-5 h-5 absolute right-4 top-3 dark:text-neutral-200 text-neutral-400"
										onClick={(e) => {
											setPassword2({ ...password2, peek: true });
											e.preventDefault();
										}}
									/>
								)}
							</div>
						</label>
						<label
							className="flex col-span-2 justify-center items-center"
							htmlFor="agreement"
						>
							<input
								id="agreement"
								type="checkbox"
								className="focus:ring-action-primary h-4 w-4 text-primary border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500"
								defaultChecked={!agreement}
								onChange={() => {
									setAgreement(!agreement);
								}}
							/>
							<span className="text-neutral-800 dark:text-neutral-200 ml-2 text-center ">
								Saya setuju dengan{" "}
								<Link to={"/snk"}>
									<strong>syarat dan ketentuan</strong>
								</Link>
							</span>
						</label>
						<ButtonPrimary
							type="submit"
							className={`col-span-2 ${
								!agreement
									? "bg-primary-6000 dark:bg-primary-6000 hover:bg-primary-700"
									: "bg-blueGray-500 dark:bg-blueGray-500 cursor-not-allowed"
							}`}
							disabled={agreement}
						>
							{loading ? "Loading..." : "Daftar"}
						</ButtonPrimary>
					</form>

					{/* OR */}
					<div className="relative text-center">
						<span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
							ATAU
						</span>
						<div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
					</div>
					{/* SOCIAL */}

					<div className="grid gap-3">
						{loginSocials.map((item, index) => (
							<div
								key={index}
								onClick={
									() => {
										handleAuth(item.method);
										eventAnalytic({
											category: "User",
											action: "register",
											label: "Auth Google",
										});
									} /*dispatch(userAuth(item.method))*/
								}
								className="nc-will-change-transform flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
							>
								<img
									className="flex-shrink-0"
									src={item.icon}
									alt={item.name}
								/>
								<h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
									{item.name}
								</h3>
							</div>
						))}
					</div>

					{/* ==== */}
					<span className="block text-center text-neutral-700 dark:text-neutral-300">
						Sudah punya akun? {` `}
						<Link to={`/login${window.location?.search || ""}`}>
							<strong>Masuk</strong>
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default PageSignUp;
